/*
 * https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/
 */
import { infiniteHits } from "instantsearch.js/es/widgets";
import { generatorHitTpl } from './tpl/generatorHitTpl';
import { containers } from "./selectors"

export const generatorsSearchResults = infiniteHits({
    container: containers.results,
    escapeHTML: true,
    cssClasses: {
        list: [
            'md:grid-cols-12 md:grid md:gap-4'
        ],
        item: [
            'text-left md:col-span-6 lg:col-span-4 xl:col-span-3'
        ],
        loadMore: [
            'button button--small mt-6 mb-10'
        ],
        disabledLoadMore: [
            'hidden'
        ]
    },
    templates: {
        item: generatorHitTpl,
        empty: ``,
        showMoreText: 'Show more',
    },
})
